import {Component, Input} from '@angular/core';
import {Filter} from "../../../../../search/search-list/filters/filter-block/filter-item/filter";
import {FilterBaseComponent} from "../../../../../search/search-list/filters/filter-block/filter-base/filter-base.component";
import {FacetService} from "../../facet.service";
import {MessageService} from "../../../../../messages/message.service";
import {Toast} from "../../../../../dialog/alert/toastr/toast";
import {ToastType} from "../../../../../dialog/alert/toastr/toast-type.enum";

@Component({
  selector: 'app-facet-phrase',
  templateUrl: './facet-phrase.component.html',
  styleUrls: ['./facet-phrase.component.scss']
})
export class FacetPhraseComponent extends FilterBaseComponent {

  phraseField: string;

  @Input() blockId: string;

  constructor(private facetService: FacetService, private messageService: MessageService) {
    super();
  }

  isSimpleFilterAllowed(): boolean {
    return false;
  }

  doRefresh() {
  }

  appendFilter() {
    if (this.phraseField && this.phraseField.length > 0 && this.phraseField.trim() && this.phraseField.trim().length > 0) {
      this.facetService.appendFilter(new Filter({
        field: this.filterBlock.filterConfig.name,
        selected: true,
        value: this.phraseField
      }));
      this.clearPhrase();
      this.facetService.navigateByFilters(false, true);
    } else {
      this.messageService.add(new Toast('Uzupełnij pole', 'Pole nie zostało uzupełnione', ToastType.INFO));
    }
  }

  private clearPhrase() {
    this.phraseField = "";
  }
}
